/**
 * Helper to safely pluck an error message from rhf's `errors` map.
 * Returns `undefined` when the field has no error or the error has no
 * message (e.g. when validation is mid-flight).
 *
 * Why a helper: rhf's `FieldErrors` type is keyed by the form's value
 * shape, but our context is generic over `FieldValues = Record<string,
 * unknown>`, so a direct property access doesn't narrow. The cast is
 * isolated here so individual field components don't all reach into the
 * untyped errors map themselves.
 */
export function readErrorMessage(
  errors: Record<string, unknown>,
  name: string,
): string | undefined {
  const entry = errors[name] as { message?: unknown } | undefined;
  if (entry && typeof entry.message === "string") {
    return entry.message;
  }
  return undefined;
}
